import {
  SimulatorModulesConfig,
  SimulatorRouteConfig
} from "@constants/simulatorRouting";
import { useMemo } from "react";

export const useSimulatorRouteConfig = (): SimulatorRouteConfig[] => {
  const simulatorPages = useMemo(() => {
    return Object.keys(SimulatorModulesConfig).map((module) => {
      const moduleConfig = SimulatorModulesConfig[module];
      return {
        ...moduleConfig
      };
    });
  }, []);

  return simulatorPages;
};
